import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { get as _get, isEqual as _isEqual } from "lodash";
import { connect } from "react-redux";

import { showAlertMessage, CustomModal } from "../../../../resusableComponents/common/formElements";
import { withRouter } from "../../../../resusableComponents/hoc/withRouter";
import EnrichDataSources from "../../../../resusableComponents/common/dataSearchTable/components/EnrichDataSources";

import { getDataSources, getSavedSearchRecords } from "../../../../redux/services/enrich";
import { updatePageOperationLevelLoadingState } from "../../../../redux/actions/application";

class EnrichButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeRequestCount: 0,
      dataSourceList: [],
      showModal: false,
      totalSearchRecords: 0
    }
  }

  componentDidMount() {
    this._fetchDataSource();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (!_isEqual(prevProps.savedSearchId, this.props.savedSearchId)) ||
      (!_isEqual(prevState.showModal, this.state.showModal) && (_get(this.state, "showModal", false) === true))
    ) {
      if (_get(this.props, "savedSearchId", null) === null) {
        this.setState({ totalSearchRecords: 0 });
      } else {
        this._fetchSavedSearchRecords();
      }
    }
  }

  _incrementLoader = () => {
    const { updatePageOperationLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageOperationLevelLoadingState === "function") { updatePageOperationLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageOperationLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageOperationLevelLoadingState === "function") { updatePageOperationLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _fetchDataSource = async () => {
    try {
      this._incrementLoader();

      const response = await getDataSources();

      if ((response.flag || false) === true) {
        this.setState({ dataSourceList: _get(response, "data.data_source", []) });
      } else {
        if (_get(response, "statusCode", 400) !== 401) {
          showAlertMessage(_get(response, "message", "Something went wrong while fetching data sources details."));
        }
      }

    } catch (error) {
      if (_get(error, "statusCode", 400) !== 401) {
        showAlertMessage(_get(error, "message", "Something went wrong while fetching data sources details."));
      }

    } finally {
      this._decrementLoader();
    }
  }

  _handleReset = () => {
    this.setState({ activeRequestCount: 0, showModal: false, totalSearchRecords: 0 });
  }

  _handleShowModal = () => {
    const { savedSearchId } = this.props;

    if (!savedSearchId) {
      showAlertMessage("Please save search for the contact enrichment.");
      return;
    }

    this.setState({ showModal: true });
  }

  _fetchSavedSearchRecords = async () => {
    const { savedSearchId } = this.props;

    if (!savedSearchId) {
      showAlertMessage("Search id is missing, Please refresh the page and try again.");
      return false;
    }

    try {
      this._incrementLoader();

      const response = await getSavedSearchRecords({ search_id: (savedSearchId || null) });

      if (_get(response, "flag", false) === true) {

        this.setState({ totalSearchRecords: _get(response, "data.total_records", 0) });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching saved search total records."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching saved search total records."));

    } finally {
      this._decrementLoader();
    }
  }

  _renderEnrichModal = () => {
    const { savedSearchId, intl } = this.props;
    const { dataSourceList, showModal, totalSearchRecords } = this.state;

    return (
      <CustomModal
        baseClassName="modal-xl"
        modalTitleClassName="heading-04 text-uppercase"
        bodyClassName="text-capitalize-first"
        isOpen={(showModal || false)}
        onClose={() => this._handleReset()}
        showCloseButton={true}
        modalTitle={intl.formatMessage({ "id": "data_search.enrich_modal.title", defaultMessage: "Data Search - Enrich" })}
      >
        <EnrichDataSources
          selectedSavedSearchId={{ id: (savedSearchId || null), search_name: "saved search" }}
          dataSourceList={(dataSourceList || [])}
          resetParentProps={() => this._handleReset()}
          savedSearchId={null}
          fileUploaded={false}
          uploadedFileName=""
          uploadedFileURL=""
          defaultCheckedDataFields={[]}
          source="data_search"
          totalRecords={(totalSearchRecords || 0)}
        />
      </CustomModal>
    );
  }


  render() {
    return (
      <>
        <div className="d-flex flex-grow-1 flex-sm-grow-0">
          <button type="button" className="btn btn-primary waves-effect flex-fill" onClick={() => this._handleShowModal()}>
            <img src={require("../../../../assets/icons/icon-enrich.svg").default} className="img-fluid me-1" alt="" />
            <FormattedMessage id="btn.enrich" defaultMessage="enrich" />
          </button>
        </div>

        {this._renderEnrichModal()}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  updatePageOperationLevelLoadingState: (data) => dispatch(updatePageOperationLevelLoadingState(data)),
});

export default connect(null, mapDispatchToProps)(withRouter(injectIntl(EnrichButton)));
